export default "__VITE_ASSET__SvkfBXbd__"